import authClient from '@/plugins/axios/authClient'
import defaultClient from '@/plugins/axios/defaultClient'
import $store from '@/store'

export default {
  /**
   *
   * @param {*} refresh 토큰
   * @returns
   */
  signinKakao(param) {
    return authClient.post('/auth/kakao/', param)
  },
  signinRefresh({ token }) {
    return authClient.post('/auth/refresh-token/', {
      token,
    })
  },
  getMe() {
    return defaultClient.get('/users/me/')
  },
  patchMe({ uuid, me }) {
    return defaultClient.patch(`/users/${uuid}/`, me)
  },
  signinIdPassword({ email, password }) {
    return authClient.post('/auth/login/', { email, password })
  },
  earlyPaymentLoanRequest(params) {
    console.log('params:', params)
    return defaultClient.post('/early-payments/loan-requests/', params)
  },
}
